import {
  IForEachSchemaOptions,
  ISchemaNode,
  Schema,
  forEachSchemaNode,
  yup,
} from '@framework/validation';
import { TriggerModuleMetaKey } from './ModuleTriggerWidget.type';
import {
  ITriggeredModuleMeta,
  ModuleTriggerModuleUniqueCodeMetaKey,
  ModuleTriggerTitleMetaKey,
} from './createModuleTriggerFormSchema';

export interface ITriggeredModule {
  idModulo: string;
  idAttivazione: string;
  codiceUnivoco: string;
  titolo: string | null | undefined;
}

export function getActivationId(moduleRequestId: string, node: ISchemaNode) {
  return `${moduleRequestId}.${node.path}`;
}

/**
 * In fase di validazione, estrae dal form i moduli che sono stati effettivamente
 * attivati dalle regole impostate nel widget "Attivazione modulo".
 */
export function extractTriggeredModules(
  schema: yup.ISchema<any>,
  options: IForEachSchemaOptions,
) {
  const triggeredModules: ITriggeredModule[] = [];

  forEachSchemaNode(schema, options, node => {
    if (
      node.schema instanceof Schema &&
      node.schema.meta?.()?.[TriggerModuleMetaKey] &&
      !node.schema.spec.strip
    ) {
      // Se è false, non è stato attivato
      if (node.value === false) return;

      const meta = node.schema.meta?.();
      const triggeredModuleMeta = meta?.[
        TriggerModuleMetaKey
      ] as ITriggeredModuleMeta | null;

      if (!triggeredModuleMeta) {
        console.warn(`Errore: Meta non trovati per ${node.path}`, { node }); // prettier-ignore
        return;
      }

      const { moduleId } = triggeredModuleMeta;

      // Se non c'è il moduleId probabilmente il widget non è stato configurato e non c'è nessun modulo da valutare
      if (!moduleId) {
        return;
      }

      const uniqueModuleCode =
        node.schema.meta?.()?.[ModuleTriggerModuleUniqueCodeMetaKey];

      const title = node.schema.meta?.()?.[ModuleTriggerTitleMetaKey];

      if (!options.moduleRequestId) {
        console.warn('Attenzione: moduleRequestId non impostato', { node });
      }

      const activationId = getActivationId(
        options.moduleRequestId ?? '<unknown>',
        node,
      );

      triggeredModules.push({
        idModulo: moduleId,
        idAttivazione: activationId,
        codiceUnivoco: uniqueModuleCode ?? activationId,
        titolo: title,
      });
    }
  });

  return triggeredModules;
}
